import { render, staticRenderFns } from "./PatientSummary.vue?vue&type=template&id=6ba8b272"
import script from "./PatientSummary.vue?vue&type=script&lang=js"
export * from "./PatientSummary.vue?vue&type=script&lang=js"
import style0 from "./PatientSummary.vue?vue&type=style&index=0&id=6ba8b272&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports